import { debug } from "@/config";

/* main */
let projectKey = 'eaf3c8f60df1f92b8792bc596f5dfax8';
let openUrlSLD = 'bscscan.com';

// 拍卖合约地址
let rwaartAddress= '0xc49a9A585deca3E40fDdf6E1A579A020509E5d11';


const setProjectConfig = async () => {
    // BSC
    openUrlSLD = 'bscscan.com';
    // 拍卖合约地址
    rwaartAddress= '0x449256d45689E958F000e59F6A2EE529B2D536F6';

    /* test */
    if (debug) {
        // BSC
        openUrlSLD = 'testnet.bscscan.com';
    }
}

export {
    projectKey,
    openUrlSLD,
    rwaartAddress,
    setProjectConfig
}
